window.NopaWishlist = (() => {
  const KEY = 'nopa:wishlist';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  const write = (list) => {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('nopa:wishlist:change', { detail: { list } }));
  };
  const has = (handle) => read().includes(handle);
  const toggle = (handle) => {
    if (!handle) return false;
    const list = read();
    const i = list.indexOf(handle);
    i === -1 ? list.push(handle) : list.splice(i, 1);
    write(list);
    return i === -1;
  };
  const syncButtons = (root) => {
    (root || document).querySelectorAll('[data-nopa-wishlist-toggle]').forEach((btn) => {
      const active = has(btn.dataset.handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active);
    });
  };
  if (!window.__nopaWishlistBound) {
    window.__nopaWishlistBound = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest ? e.target.closest('[data-nopa-wishlist-toggle]') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      toggle(btn.dataset.handle);
      btn.classList.add('is-popping');
      setTimeout(() => btn.classList.remove('is-popping'), 300);
      syncButtons();
    });
    document.addEventListener('nopa:wishlist:change', () => syncButtons());
    document.addEventListener('shopify:section:load', () => syncButtons());
    if (document.readyState !== 'loading') syncButtons();
    else document.addEventListener('DOMContentLoaded', () => syncButtons());
  }
  return { read, has, toggle, syncButtons };
})();
